import { CONDENSED_PDP_XP_240409 } from "@faire/web-api/indigofair/settings/CONDENSED_PDP_XP_240409";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingEnableCondensedPDP = (): boolean => {
  return getSettingValueWithoutAssignment(CONDENSED_PDP_XP_240409, false);
};
